import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

class PaymentFail extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <h1>
            <FormattedMessage
              id="app.paymentfail.title"
              defaultMessage="Maksu epäonnistui"
            />
          </h1>
          <p>
            <FormattedMessage
              id="app.paymentfail.text"
              defaultMessage="Maksussa tapahtui virhe."
            />
          </p>
          <p>
            <Link to={"/dashboard"} className={"btn btn-primary"}>
              <FormattedMessage
                id="app.paymentsuccess.return"
                defaultMessage="Palaa etusivulle"
              />
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

export default PaymentFail;



// WEBPACK FOOTER //
// ./src/containers/Payment/PaymentFail.js